import { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import styled from "styled-components";
import { BsPencil, BsChevronDown, BsChevronUp } from "react-icons/bs";
import { MdFileDownload, MdAddCircle } from "react-icons/md";

const HelpSupportSuper = () => {
    return (
        <Wrapper>
            <div className="container pt-5 pb-3">
                <div className="card border-0 shadow-sm p-4">
                    <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
                        <div>
                            <h4 className="text-dark mb-1">Help & Support Center</h4>
                            <p className="text-muted mb-0">
                                Manage support ticket FAQs and provide assistance to user and partner
                            </p>
                        </div>
                        <div className="d-flex gap-3 mt-2 mt-md-0">
                            <button className="btn btn-outline-primary d-flex align-items-center">
                                <MdFileDownload className="me-2" size={20} />
                                Filter Ticket
                            </button>
                            <button className="btn btn-primary d-flex align-items-center">
                                <MdAddCircle className="me-2" size={20} />
                                New Ticket
                            </button>
                        </div>
                    </div>

                    <TableWrapper>
                        <table className="table table-bordered align-middle">
                            <thead className="table-light">
                                <tr>
                                    <th>ID</th>
                                    <th>Subject</th>
                                    <th>User</th>
                                    <th>Status</th>
                                    <th>Priority</th>
                                    <th>Last Updated</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><strong>ST001</strong></td>
                                    <td>Unable to complete booking B008</td>
                                    <td>Harry Potter</td>
                                    <td><span className="badge status-open">Open</span></td>
                                    <td><span className="badge priority-high">High</span></td>
                                    <td>Jul 28, 2024, 2:00 PM</td>
                                    <td className="text-center"><BsPencil /></td>
                                </tr>
                                <tr>
                                    <td><strong>ST002</strong></td>
                                    <td>Question about group discount</td>
                                    <td>Fiona Gallagher</td>
                                    <td><span className="badge status-progress">In Progress</span></td>
                                    <td><span className="badge priority-medium">Medium</span></td>
                                    <td>Jul 28, 2024, 2:45 PM</td>
                                    <td className="text-center"><BsPencil /></td>
                                </tr>
                                <tr>
                                    <td><strong>ST003</strong></td>
                                    <td>Refund status for R002</td>
                                    <td>Alice Wonderland</td>
                                    <td><span className="badge status-resolved">Resolved</span></td>
                                    <td><span className="badge priority-low">Low</span></td>
                                    <td>Jul 21, 2024, 7:30 PM</td>
                                    <td className="text-center"><BsPencil /></td>
                                </tr>
                            </tbody>
                        </table>
                    </TableWrapper>
                </div>
            </div>

            <FaqAccordion />
            <div className="container mt-4">
                <div className="card border-0 shadow-sm p-4">
                    <div className="card border shadow-sm p-3 mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <div>
                                <strong>Integrations Support</strong> &nbsp;•&nbsp; <strong>Products</strong>
                            </div>
                            <span className="badge bg-danger-subtle text-danger">Closed</span>
                        </div>
                        <div className="text-muted mb-2" style={{ fontSize: "14px" }}>
                            Ticket # 15039144 &nbsp;•&nbsp; Raised 23 days ago
                        </div>
                        <div className="text-dark">
                            Regarding Subscription, pricing and integration with my platform
                        </div>
                    </div>
                </div>
            </div>
        </Wrapper>
    );
};

export default HelpSupportSuper;

const FaqAccordion = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const faqData = [
        { question: 'How can I reset my password?', answer: 'Click on "Forgot Password" on the login page and follow the instructions.' },
        { question: 'How do I contact support?', answer: 'You can contact support by creating a support ticket or emailing support@example.com.' },
        { question: 'Where can I view my ticket status?', answer: 'Check the "My Tickets" section in your account dashboard.' },
        { question: 'How long does it take to get a response?', answer: 'Our support team usually responds within 24-48 business hours.' },
        { question: 'Can I edit a submitted ticket?', answer: 'You can’t edit a ticket after submission, but you can add comments.' },
    ];

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="container">
            <div className="card border-0 shadow-sm p-4">
                <h4 className="text-dark mb-1">Frequently Asked Questions</h4>
                <p className="text-muted mb-4">Click a question to view the answer.</p>

                {faqData.map((item, index) => (
                    <div key={index} className="mb-2 border rounded">
                        <div
                            className="p-3 bg-light d-flex justify-content-between align-items-center"
                            style={{ cursor: 'pointer' }}
                            onClick={() => toggleAccordion(index)}
                        >
                            <strong>{item.question}</strong>
                            {openIndex === index ? <BsChevronUp /> : <BsChevronDown />}
                        </div>
                        {openIndex === index && (
                            <div className="p-3 text-muted">
                                {item.answer}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

const Wrapper = styled.div`
  border-radius: 10px;
  font-size: 15px;
  .badge {
    font-size: 12px;
    padding: 5px 10px;
    border-radius: 12px;
  }
`;

const TableWrapper = styled.div`
  .badge {
    padding: 6px 12px;
    font-size: 0.75rem;
    border-radius: 12px;
    font-weight: 500;
  }

  .table td,
  .table th {
    vertical-align: middle;
    text-align: center;
  }

  table {
    width: 100%;
    font-size: 14px;
    border-collapse: collapse;
  }

  th {
    background-color: #f8f9fa;
  }

  .status-open {
    background-color: rgba(13, 202, 240, 0.15);
    color: #0dcaf0;
  }

  .status-progress {
    background-color: rgba(0, 123, 255, 0.15);
    color: #0d6efd;
  }

  .status-resolved {
    background-color: rgba(25, 135, 84, 0.15);
    color: #198754;
  }

  .priority-high {
    background-color: rgba(255, 193, 7, 0.15);
    color: #fd7e14;
  }

  .priority-medium {
    background-color: rgba(255, 193, 7, 0.15);
    color: #ffc107;
  }

  .priority-low {
    background-color: rgba(108, 117, 125, 0.15);
    color: #6c757d;
  }
`;
